import classNames from 'classnames';
import { HTMLProps, ReactNode } from 'react';
import { Heading, Overlay } from 'yoso';
import { Content } from '~/components/Content';
import { ContentModel } from '~/components/Content/Content.hooks';
import styles from './NftContent.module.scss';

export type NftContentProps = ContentModel & {
  title?: ReactNode;
  className?: string;
  children?: ReactNode;
  size?: 'small' | 'medium' | 'large';
} & Pick<HTMLProps<HTMLDivElement>, 'onClick'>;

export const NftContent = ({
  title,
  contentsUrl,
  originContentsUrl = contentsUrl,
  contentsType,
  className,
  children,
  size = 'medium',
  ...props
}: NftContentProps) => (
  <Overlay className={classNames(styles.root, className, styles[size])} {...props}>
    <div className={styles.body}>
      <Content
        originContentsUrl={originContentsUrl}
        contentsUrl={contentsUrl}
        contentsType={contentsType}
        className={styles.content}
      />
    </div>
    {title && (
      <div className={styles.footer}>
        <Heading level={5}>{title}</Heading>
      </div>
    )}
    {children}
  </Overlay>
);
